export const COOKIE_ACCEPTED_ALL = 'accepted-cookies';
export const COOKIE_ACCEPTED_ALL_TRUE = 'true';
export const COOKIE_ACCEPTED_ALL_FALSE = 'false';
